import cx from 'classnames';
import { MouseEventHandler } from 'react';

import { css } from '@flipster/styled-system/css';
import { flex, hstack } from '@flipster/styled-system/patterns';

import { MobileHeaderItem, OrderByType } from '../../../types';
import { Sort } from './sort';

interface Props {
  columns?: MobileHeaderItem[];
  sortKey?: string;
  sortOrder: OrderByType;
  onChangeSorting?: (sorting: [key: string | undefined, orderBy: OrderByType]) => unknown;
  className?: string;
}

export const MobileListHeader = ({ columns, sortKey, sortOrder, onChangeSorting, className }: Props) => {
  const onClickSorting: MouseEventHandler<HTMLButtonElement> = (e) => {
    const key = e.currentTarget.value;
    if (key === sortKey && sortOrder === 'asc') {
      onChangeSorting?.([undefined, undefined]);
      return;
    }
    onChangeSorting?.([key, key !== sortKey ? 'desc' : 'asc']);
  };

  if (!columns?.length) return null;

  return (
    <ul
      className={cx(
        hstack({
          zIndex: 1,
          gap: 8,
          p: 16,
          position: 'sticky',
          justifyContent: 'flex-start',
          backgroundColor: 'background.default.level-0',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderColor: 'border.default.level-1',
        }),
        css({
          top: 'calc(var(--current-navigation-height) + var(--market-discover-tab-height) + var(--market-tab-height) - 3px)',
        }),
        // th
        className,
      )}
    >
      {columns.map((column) => {
        const items = 'items' in column ? column.items : [column];
        return (
          <li
            key={items.map((i) => i.key).join('/')}
            style={{ width: column.width }}
            className={css(
              {
                display: 'flex',
                minWidth: 90,
                justifyContent: (column.align ?? 'left') === 'left' ? 'flex-start' : 'flex-end',
                textAlign: (column.align ?? 'left') === 'left' ? 'left' : 'right',
              },
              column.fullWidth && { flex: 1 },
            )}
          >
            {items.map((i) => (
              <button
                type='button'
                key={i.key}
                value={i.sortKey}
                onClick={onClickSorting}
                className={flex({
                  textStyle: 'Text/S/Regular',
                  gap: 2,
                  color: 'content.default.level-1',
                })}
              >
                <span className={css(!!sortOrder && sortKey === i.sortKey && { color: 'inverse.white' })}>
                  {i.title}
                </span>
              </button>
            ))}
            {items.some((v) => v.sortKey) && (
              <Sort isSorted={items.some((i) => i.sortKey === sortKey)} sortOrder={sortOrder} />
            )}
          </li>
        );
      })}
    </ul>
  );
};
